import {gsap} from "gsap";

export function animateButtons() {
    const buttons = document.querySelectorAll('.btn, .wp-block-button__link');
    buttons.forEach(button => {
        button.addEventListener('mouseenter', (event) => {
            button.querySelectorAll('.bubble').forEach((bubble) => {
                bubble.remove();
            });

            button.classList.remove('bubble--reverse-animating');
            button.classList.add('bubble--animating')

            const bubble = document.createElement('span');
            bubble.classList.add('bubble');
            button.appendChild(bubble);

            const { offsetX: x, offsetY: y } = event;

            bubble.style.left = `${x}px`;
            bubble.style.top = `${y}px`;
        });
        button.addEventListener('mouseleave', () => {
            button.querySelectorAll('.bubble').forEach((bubble) => {
                button.classList.remove('bubble--animating');
                button.classList.add('bubble--reverse-animating');

                bubble.addEventListener('animationend', () => {
                    button.classList.remove('bubble--reverse-animating');
                    bubble.remove();
                });
            });
        });
    });
}

export function animateNumbers() {
    document.querySelectorAll('.number').forEach((number) => {
        const end = number.getAttribute('data-end');
        const duration = number.getAttribute('data-duration');
        if (end && duration) {
            number.innerHTML = '0';
            gsap.to(number, {
                scrollTrigger: {
                    trigger: number,
                },
                innerText: end,
                duration: duration,
                ease: 'power1.inOut',
                snap: { innerText: 1 },
                onUpdate: function() {
                    number.innerText = Math.ceil(number.innerText);
                }
            });
        }
    });
}